// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3SdZe","modalForm":"UpgradeEpcsModal_modalForm__2f7jP","modalFooter":"UpgradeEpcsModal_modalFooter__1h6Wd"};